import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: apiUrl,
});
let refreshTimeoutId = null;

const refreshToken = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;
  try {
    const response = await axiosInstance.post("/api/refresh");
    const { token: newToken, expires_in } = response.data;
    localStorage.setItem("token", newToken);
    scheduleTokenRefresh(expires_in);
  } catch (error) {
    console.error("Failed to refresh token:", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    } else {
      setTimeout(refreshToken, 30000);
    }
  }
};

const scheduleTokenRefresh = (expiresIn) => {
  if (refreshTimeoutId) {
    clearTimeout(refreshTimeoutId);
  }
  const refreshTime = Math.max((expiresIn - 60) * 1000, 0);
  refreshTimeoutId = setTimeout(refreshToken, refreshTime);
};

export const clearTokenRefresh = () => {
  if (refreshTimeoutId) {
    clearTimeout(refreshTimeoutId);
    refreshTimeoutId = null;
  }
};

export const initializeTokenRefresh = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return;

    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) throw new Error("Invalid token: no expiration");

    const currentTime = Math.floor(Date.now() / 1000);
    const expiresIn = payload.exp - currentTime;

    if (expiresIn > 0) {
      scheduleTokenRefresh(expiresIn);
    } else {
      refreshToken();
    }
  } catch (error) {
    console.error("Failed to initialize token:", error);
    clearTokenRefresh();
  }
};

// Request interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.config.url !== '/api/login' && error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
